import { Button } from '@storeblocks/button';
import { type FC } from 'react';

import { useOrganizationCmId } from '@/api/userSettings/hooks/useOrganizationCmId';
import { InternalLink } from '@/components/InternalLink';
import { useTexts } from '@/hooks/useTexts';
import { TrackingElement, useGetTrackId } from '@/tracking';

export const GoToDashboardButton: FC = () => {
  const texts = useTexts();
  const organizationCmId = useOrganizationCmId();

  const getTrackId = useGetTrackId();

  return (
    <Button
      variant="tertiary"
      iconRight="arrow_right"
      type="button"
      to={`/${organizationCmId}`}
      as={InternalLink}
      data-trackid={getTrackId('go-to-dashboard', TrackingElement.Link)}
    >
      {texts.orders.signatureRight.goToDashboard}
    </Button>
  );
};
